module.exports = __webpack_public_path__ + "img/BARS.2d95f806.jpg";